import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface CustomPlaceholderDTO {
  displayName: string;
  placeholder: string;
}

export class CustomPlaceholder {
  readonly isCustomPlaceholderCustomPlaceholder: boolean = true;

  readonly displayName: string;
  readonly placeholder: string;


  constructor(
  displayName: string, 
  placeholder: string
  ) {
    CustomPlaceholder.validateDisplayName(displayName);
    this.displayName = displayName;
    CustomPlaceholder.validatePlaceholder(placeholder);
    this.placeholder = placeholder;
  }

  static fromDTO(dto: CustomPlaceholderDTO): CustomPlaceholder {
    const displayName = getString(dto, "displayName", InvalidCustomPlaceholderDisplayNameError);
    const placeholder = getString(dto, "placeholder", InvalidCustomPlaceholderPlaceholderError);
    return new CustomPlaceholder(
      displayName,
      placeholder
    );
  }

  toDTO(): CustomPlaceholderDTO {
    const dto: CustomPlaceholderDTO = {
        displayName: this.displayName,
        placeholder: this.placeholder
    };
    return dto;
  }
  private static validateDisplayName = (displayName: string): void => {
    if(displayName.trim().length === 0) {
      throw new InvalidCustomPlaceholderDisplayNameNonEmptyError(
        `Attribute displayName cannot be an empty string.`
      );
    }
  }
  private static validatePlaceholder = (placeholder: string): void => {
    if(placeholder.trim().length === 0) {
      throw new InvalidCustomPlaceholderPlaceholderNonEmptyError(
        `Attribute placeholder cannot be an empty string.`
      );
    }
  }
  
}

CustomPlaceholder.prototype.toString = function toString(): string {
  return `CustomPlaceholder(displayName='${this.displayName}',placeholder='${this.placeholder}')`;
};

export class InvalidCustomPlaceholderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCustomPlaceholderError";
  }
}
export class InvalidCustomPlaceholderDisplayNameError extends InvalidCustomPlaceholderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCustomPlaceholderDisplayNameError";
  }
}

export class InvalidCustomPlaceholderDisplayNameNonEmptyError extends InvalidCustomPlaceholderDisplayNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCustomPlaceholderDisplayNameNonEmptyError";
  }
}

export class InvalidCustomPlaceholderPlaceholderError extends InvalidCustomPlaceholderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCustomPlaceholderPlaceholderError";
  }
}

export class InvalidCustomPlaceholderPlaceholderNonEmptyError extends InvalidCustomPlaceholderPlaceholderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCustomPlaceholderPlaceholderNonEmptyError";
  }
}
